export enum NetworkError {
  MidiDownloadFailed = 'midi-download-failed',
  MidiFileParseFailed = 'midi-file-parse-failed', // technically not a network error...
  MP3DownloadFailed = 'mp3-download-failed',
  MP3GenerationFailed = 'mp3-generation-failed',
  TextDownloadFailed = 'text-download-failed',
  TextFileParseFailed = 'text-file-parse-failed',
  VideoLoadFailed = 'video-load-failed', // a practice video: the YouTube API or the video did not load (offline)
  VideoUnavailable = 'video-unavailable', // a practice video YouTube will not play: a bad id, removed, or not embeddable
  // TODO(remove after 2027-11-01): a practice video inside an iOS store app older than 24.0.2, which would open Safari
  // instead of embedding it (GitHub issue #4058); delete with canShowPracticeVideoInApp in practice_video_support.ts
  VideoNeedsAppUpdate = 'video-needs-app-update',
  Unknown = 'unknown',
}
